// Tiny pub/sub so any successful library removal or restore (DELETE
// /library/{type}/{id}, POST /library/restore, POST /library/trash/restore)
// can tell LibrarySubNav's "Recently Removed" badge to refetch its count
// immediately instead of only on the next full page mount. See api.js's
// response interceptor (the single place that sees every one of those
// calls) and LibrarySubNav.js (the subscriber). Same pattern as statusBus.js.
const listeners = new Set();

export function subscribeTrashChange(cb) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

export function emitTrashChange() {
  listeners.forEach((cb) => {
    try { cb(); } catch { /* ignore a bad subscriber */ }
  });
}
